import { render, staticRenderFns } from "./child_btn_precio.vue?vue&type=template&id=738542eb&scoped=true"
import script from "./child_btn_precio.vue?vue&type=script&lang=js"
export * from "./child_btn_precio.vue?vue&type=script&lang=js"
import style0 from "./child_btn_precio.vue?vue&type=style&index=0&id=738542eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738542eb",
  null
  
)

export default component.exports